const TablePaginationActionsStyles = () => ({
  root: {
    flexShrink: 0,
    marginLeft: 50,
  },
});

export default TablePaginationActionsStyles;
